export default "__VITE_ASSET__DTlBwKl0__"